import { useEffect, useMemo, useRef, useState, useCallback } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import {
  _ProcedureImp,
  _RequestMaintenance,
  _single,
  _WorkMaintenanceOrder,
} from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { CardTaps } from "../../../../../theme/Component/CardTaps";
import { SelectTechnicians } from "../../../../../Factoty&Production/Maintenance/Technicians/SelectTechnicians";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";
import { SelectSeverityLevels } from "../../../../../Factoty&Production/Maintenance/SeverityLevels/SelectSeverityLevels";
import { SelectErrorDetails } from "../../../../../Factoty&Production/Maintenance/ErrorTypes/ErrorDetails/SelectErrorDetails";
import { AtachDocument } from "../../../../../theme/Component/AtachDocument";
import { _FixedAssetItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { PrintJson } from "../../../../../theme/Component/PrintJson";

interface ProcedureFunctions {
  _exportMap: Function;
  _procedure: any;
  _pocessData?: any;
  _pushInfo?: Function;
  _pushProps?: Function;
}

interface Props {
  configProcedure: ProcedureFunctions;
}

function shallowEqual(a: any, b: any) {
  if (a === b) return true;
  if (!a || !b) return false;
  const ka = Object.keys(a);
  const kb = Object.keys(b);
  if (ka.length !== kb.length) return false;
  for (const k of ka) {
    if (a[k] !== b[k]) return false;
  }
  return true;
}

export const MD012 = ({ configProcedure }: Props) => {
  const { instance, bean, setBean } = useDataBean(_RequestMaintenance);
  const order = useDataBean(_WorkMaintenanceOrder);
  const item = useDataBean(_FixedAssetItem);

  const [props, setProps] = useState<any>({});
  const [indexTap, setIndexTap] = useState(0);
  const [document, setDocument] = useState<any>([]);
  const propsRef = useRef<any>({});
  const pushQueueRef = useRef<Promise<any>>(Promise.resolve());

  const procedureId = useMemo(
    () => configProcedure?._procedure?.IDProcedureImp ?? null,
    [configProcedure?._procedure?.IDProcedureImp]
  );

  const fetchedProcedureIdRef = useRef<number | null>(null);
  const fetchedItemIdRef = useRef<number | null>(null);

  const pushMergedProps = useCallback((partialProps: any) => {
    const definedProps = Object.entries(partialProps ?? {}).reduce((acc: any, [key, value]) => {
      if (key === "IDWorkMaintenanceOrder" && (value === undefined || value === null || value === "")) return acc;
      if (value !== undefined) acc[key] = value;
      return acc;
    }, {});

    const next = {
      ...propsRef.current,
      ...definedProps,
    };

    propsRef.current = next;
    setProps((prev: any) => (shallowEqual(prev, next) ? prev : next));

    pushQueueRef.current = pushQueueRef.current
      .catch(() => undefined)
      .then(() => configProcedure?._pushProps?.(next));

    return pushQueueRef.current;
  }, [configProcedure]);

  useEffect(() => {
    const data = configProcedure?._pocessData?.Props;
    if (data) {
      propsRef.current = data;
      setProps((prev) => (shallowEqual(prev, data) ? prev : data));
    }
  }, [configProcedure?._pocessData?.Props]);

  useEffect(() => {
    if (!procedureId) return;
    if (fetchedProcedureIdRef.current === procedureId) return;

    fetchedProcedureIdRef.current = procedureId;

    const properties = { IDProceudreIMP: procedureId };

    instance
      .getRequestMaintenanceCatalogPorPropiedades(properties, null)
      .then((resp) => {
        const data = resp?.[0]?.DataBeanProperties;
        if (!data) return;
        pushMergedProps(data);
        setBean(data);
      })
      .catch(() => {
        toast.dismiss();
        toast.error("No se cargó la información del procedimiento");
      });
  }, [procedureId, instance, setBean, pushMergedProps]);

  useEffect(() => {
    const idItem = bean?.IDFixedAssetItem;
    if (!idItem) return;
    if (fetchedItemIdRef.current === idItem) return;

    fetchedItemIdRef.current = idItem;

    item.instance.getMaintenanceFixedAssetItem(idItem).then((resp) => {
      if (!resp) {
        toast.dismiss();
        toast.error("La máquina no existe o no tiene datos");
        return;
      }

      const mapped = {
        InternalCode: resp.InternalCode,
        AssetEntity: resp.FixedAssetName,
        SupplierModel: resp.SupplierModel,
        TicketCode: resp.TicketCode,
        SerialNumber: resp.SerialNumber,
        SiteName: resp.SiteName,
        MaintenanceName: resp.LocationMaintenanceName,
      };

      item.setBean(mapped);
      pushMergedProps(mapped);
    }).catch(() => {
      toast.dismiss();
      toast.error("No se cargó la información de la máquina");
    });
  }, [bean?.IDFixedAssetItem, item.instance, pushMergedProps]);

  useEffect(() => {
    setBean((prev: any) => {
      const jsonDocs = JSON.stringify(document);
      if (prev.JSONListDocument === jsonDocs) return prev;
      return { ...prev, JSONListDocument: jsonDocs };
    });
  }, [document, setBean]);

  const renderState = (maintenanceType: string) => {
    switch (maintenanceType) {
      case "NA":
        return "Funcionando";
      case "Replacement":
        return "Mantenimiento";
      case "Calibration":
        return "Calibración";
      default:
        return "No Reportado";
    }
  };

  const updateForm = (State: number, renderType?: string) => {
    const x = { ...bean, State };
    if (renderType) x.RenderMaintenanceType = renderState(renderType);
    instance.updateRequestMaintenance(x).then((resp) => {
      console.log(resp)
      const data = resp;
      console.log("Actualizar RequesMaintenance=>", data)
      if (data) {
        setBean(data);
      }
    })
      .catch(() => toast.error("Error al actualizar el mantenimiento"));
  };

  const updateOrder = useCallback((ObservationsOrder: string, StateOrder: number, IDItemOrder: number, IDEmployeeOrder: number, IDRequestMaintenance: number, IDWorkMaintenanceOrder?: number, extraProps: any = {}) => {

    return order.instance.updateWorkMaintenanceOrder({ IDWorkMaintenanceOrder, Observations: ObservationsOrder, State: StateOrder, IDItem: IDItemOrder, IDEmployee: IDEmployeeOrder, IDRequestMaintenance: IDRequestMaintenance }).then((resp) => {
      const orderId = resp?.IDWorkMaintenanceOrder ?? IDWorkMaintenanceOrder;

      console.log("Actualizar IDWorkMaintenanceOrder =>", orderId);

      return pushMergedProps({
        ...extraProps,
        IDEmployeeOrder: resp?.IDEmployee,
        StateOrder: resp?.State,
        IDRequestMaintenance: resp?.IDRequestMaintenance,
        ObservationsOrder: resp?.Observations,
        IDItemOrder: resp?.IDItem,
        IDWorkMaintenanceOrder: orderId,
      });
    })
      .catch(() => toast.error("Error al actualizar la orden"));
  }, [order.instance, pushMergedProps]);


  const onExportMap = useCallback(() => {
    const x = { ...bean, State: 3 };

    instance.updateRequestMaintenance(x).then((resp) => {
      const data = resp?.[0]?.DataBeanProperties ?? x;

      configProcedure?._pushInfo?.(
        _single.jsonToBootstrapTable({
          "Maquina / Objeto": props.AssetEntity,
          Ubicación: props.SiteName,
          "Tipo de Mantenimiento": renderState(bean.Type),
          "Técnico Asignado": bean.IDTechnicianName,
        })
      );

      configProcedure?._exportMap?.({
        ...bean,
        UsedSparedParts: bean.UsedSparedParts ? "true" : "false",
      });

      if (props.IDWorkMaintenanceOrder) {
        return updateOrder(
          props.ObservationsOrder,
          bean.UsedSparedParts ? 2 : 0,
          props.IDItemOrder,
          props.IDEmployeeOrder,
          props.IDRequestMaintenance,
          props.IDWorkMaintenanceOrder,
          data
        );
      }

      return pushMergedProps(data);
    })
      .catch(() => toast.error("No se pudo realizar la acción"));
  }, [bean, instance, configProcedure, props, pushMergedProps, updateOrder]);

  const taps = [
    { id: 0, name: "Maquina", disable: false },
    { id: 1, name: "Técnico a Cargo", disable: true },
    { id: 2, name: "Repuestos", disable: true },
  ];

  useEffect(() => {
    if (!bean?.ReviewDate) {
      setBean((prev: any) => ({
        ...prev,
        ReviewDate: _single.getCurrenDate()
      }));
    }
  }, [bean?.ReviewDate, setBean]);

  return (
    <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap}>
      {/* <div className="row">
        <div className="col-md-6"><h5>bean</h5><PrintJson json={bean} /></div>
        <div className="col-md-6"><h5>props</h5><PrintJson json={props} /></div>
      </div> */}
      {indexTap === 0 && (
        <div className="row">
          <div className="col-md-6">
            <InputDate name="" label="Fecha de Reporte" value={bean.ReportDate} setDate={(e) => setBean({ ...bean, ReportDate: e })} />
          </div>
          <div className="col-md-6">
            <label>Hora de Reporte</label>
            <div className="row">
              <div className="col-md-6">
                <select className="form-control" value={bean.ReportTimeH ?? ""} onChange={(e) =>
                  setBean({ ...bean, ReportTimeH: parseInt(e.target.value) })
                }>
                  <option value="">HH</option>
                  {[...Array(24)].map((_, i) => (
                    <option key={i} value={i}>
                      {i.toString().padStart(2, "0")}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6">
                <select className="form-control" value={bean.ReportTimeM ?? ""} onChange={(e) =>
                  setBean({ ...bean, ReportTimeM: parseInt(e.target.value) })
                }>
                  <option value="">MM</option>
                  {[...Array(60)].map((_, i) => (
                    <option key={i} value={i}>
                      {i.toString().padStart(2, "0")}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className="col-md-12 mt-3">
            <h5>Máquina Seleccionada</h5>
          </div>
          {[
            ["Código Interno", props.InternalCode],
            ["Máquina", props.AssetEntity],
            ["Modelo", props.SupplierModel],
            ["Placa", props.TicketCode],
            ["Serial", props.SerialNumber],
            ["Ubicación", props.SiteName],
            ["Área", props.MaintenanceName],
          ].map(([label, value], i) => (
            <div key={i} className="col-lg-6 my-2">
              <strong>{label}:</strong>
              <div dangerouslySetInnerHTML={{ __html: `${value ?? ""}` }} />
            </div>
          ))}

          <div className="col-md-6">
            <label>Turno de Producción</label>
            <select className="form-select" value={bean.CodeTurno} onChange={(e) =>
              setBean({ ...bean, CodeTurno: e.target.value })
            }
            >
              <option value="">...</option>
              <option value="A">A</option>
              <option value="B">B</option>
              <option value="C">C</option>
            </select>
          </div>

          <div className="col-md-6">
            <SelectSeverityLevels returnType="ID" idSelector={bean.IDPriorityMaintenance} onChange={(e) => setBean({ ...bean, IDPriorityMaintenance: e })} label="Prioridad de Mantenimiento" />
          </div>

          <div className="col-md-6">
            <SelectErrorDetails idSelector={bean.IDErrorDetails} onChange={(e) => setBean({ ...bean, IDErrorDetails: e })} label="Código de Error" returnType="ID" />
          </div>

          <div className="col-md-12">
            <label>Descripción de la Falla</label>
            <textarea className="form-control" value={bean.Observations} onChange={(e) => setBean({ ...bean, Observations: e.target.value })} />
          </div>

          <div className="col-md-12 mt-4">
            <BasicButton icon="ri-send-plane-line" children="Confirmar Información"
              eventClick={() => {
                if (bean.Observations && bean.IDFixedAssetItem && bean.IDEmployee && bean.IDRequestMaintenance) {
                  setIndexTap(1);
                  updateForm(1);
                  updateOrder(
                    `${props.IDFixedAssetItemName || bean.IDFixedAssetItemName
                    } - ${configProcedure?._procedure.AlphaCode} - ${bean.Observations}`,
                    7,
                    bean.IDFixedAssetItem,
                    bean.IDEmployee,
                    bean.IDRequestMaintenance,
                    props.IDWorkMaintenanceOrder
                  );
                } else {
                  toast.error("Descripción es obligatoria")
                }
              }}
            />
          </div>
        </div>
      )}

      {/* === Pestaña 2: Técnico === */}
      {indexTap === 1 && (
        <div className="row">
          <div className="col-md-12">
            <SelectTechnicians idSelector={bean.IDTechnicians} returnType="Object" label="Asignar Técnico a Cargo"
              onChange={(e) => {
                const tech = e.IDTechnicians ? e : {};
                setBean((prev) => ({
                  ...prev,
                  IDTechnicianName: tech?.TechnicianName,
                  IDTechnicians: tech?.IDTechnicians,
                  CodeTechnician: tech?.CodeTechnician,
                }));
              }}
            />
          </div>

          <div className="col-md-6">
            <label>Hora de Ejecución</label>
            <div className="row">
              <div className="col-md-6">
                <select
                  className="form-control"
                  value={bean.ReviewFromH ?? ""}
                  onChange={(e) =>
                    setBean({ ...bean, ReviewFromH: parseInt(e.target.value) })
                  }
                >
                  <option value="">HH</option>
                  {[...Array(24)].map((_, i) => (
                    <option key={i} value={i}>
                      {i.toString().padStart(2, "0")}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6">
                <select
                  className="form-control"
                  value={bean.ReviewFromM ?? ""}
                  onChange={(e) =>
                    setBean({ ...bean, ReviewFromM: parseInt(e.target.value) })
                  }
                >
                  <option value="">MM</option>
                  {[...Array(60)].map((_, i) => (
                    <option key={i} value={i}>
                      {i.toString().padStart(2, "0")}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <label>Tipo de Mantenimiento</label>
            <select
              className="form-select"
              value={bean.Type}
              onChange={(e) => setBean({ ...bean, Type: e.target.value })}
            >
              <option value="">...</option>
              <option value="Calibration">Requiere Calibración/Ajuste</option>
              <option value="Replacement">Requiere Repuesto</option>
              <option value="NA">N/A o no presenta falla</option>
            </select>
          </div>

          <div className="col-md-6">
            <InputDate name="" label="Fecha de Revisión" value={bean.ReviewDate} setDate={(e) => setBean({ ...bean, ReviewDate: e })} />
          </div>

          <div className="col-md-12">
            <label>Error Evidenciado (Técnico)</label>
            <textarea
              className="form-control"
              value={bean.DescriptionOperator}
              onChange={(e) =>
                setBean({ ...bean, DescriptionOperator: e.target.value })
              }
            />
          </div>

          <div className="col-md-12 mt-4">
            <BasicButton icon="ri-user-add-line" children="Asignar Técnico" eventClick={() => {
              if (props.IDWorkMaintenanceOrder) {
                setIndexTap(2);
                updateForm(2, bean.Type);
                updateOrder(props.ObservationsOrder, 0, props.IDItemOrder, props.IDEmployeeOrder, props.IDRequestMaintenance, props.IDWorkMaintenanceOrder);
              }
            }}
            />
          </div>
        </div>
      )}

      {/* === Pestaña 3: Repuestos === */}
      {indexTap === 2 && (
        <div className="row">
          <div className="col-md-6">
            <BasicSwitch estado={bean.UsedSparedParts} eventChange={(e) => setBean({ ...bean, UsedSparedParts: e })} label="¿Se solicitaron implementos?" />
          </div>

          <div className="col-md-12">
            <AtachDocument _docList={document} onChange={(e) => setDocument(e)} />
          </div>

          <div className="col-md-12 mt-4">
            <BasicButton icon="ri-check-line" children="Finalizar Reporte"
              eventClick={() => {
                onExportMap();
              }}
            />
          </div>
        </div>
      )}
    </CardTaps>
  );
};
